/**
 * provenance — compiled-from lineage derivation (FE-1 sprint-241, FR-S6.2).
 *
 * Pure derivation over the ALREADY-FETCHED graph payload — zero new fetches.
 * The backend emits COMPILED_FROM edges attestation(source) → knowledge
 * (target) ("certificate lineage", environment_graph_service.py), so a
 * node's compiled-from count is the number of COMPILED_FROM edges that
 * TARGET it.
 */

import type { D3GraphEdge, D3GraphNode } from './D3GraphCanvas';

/** D3 mutates edge ends from id-string to node-object after the simulation
 * binds — same idiom as `LineageSunburst.tsx:36-38`. */
function edgeId(end: string | D3GraphNode): string {
  return typeof end === 'string' ? end : end.id;
}

/** Count COMPILED_FROM edges targeting `nodeId` (attestation → knowledge). */
export function countCompiledFrom(nodeId: string, edges: D3GraphEdge[]): number {
  let count = 0;
  for (const e of edges) {
    if (e.type === 'COMPILED_FROM' && edgeId(e.target) === nodeId) count += 1;
  }
  return count;
}
